import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'
import 'mapbox-gl/dist/mapbox-gl.css'
import 'mapbox-gl-leaflet'

const MapboxGLBaseLayer = ({ accessToken, style }) => {
  const map = useMap()

  useEffect(() => {
    if (!accessToken || !style || !L.mapboxGL) return undefined

    const layer = L.mapboxGL({
      accessToken,
      style,
      interactive: false,
    })
    layer.addTo(map)

    const onResize = () => {
      const glMap = layer.getMapboxMap && layer.getMapboxMap()
      if (glMap && glMap.resize) {
        glMap.resize()
      }
    }
    map.on('resize', onResize)

    return () => {
      map.off('resize', onResize)
      map.removeLayer(layer)
    }
  }, [map, accessToken, style])

  return null
}

export default MapboxGLBaseLayer
